<template>
  <div class="all">
    <div class="header">
      <div class="header_wrap">
        <img src="../assets/quickfix/logo.png" alt>
        <span>Quick</span>
        <span>
          Fix.
          <span style="font-size:18px">工具中心</span>
        </span>
      </div>
    </div>
    <div class="main">
      <div class="banner">
        <el-carousel
          trigger="click"
          indicator-position="none"
          :interval="4000"
          :loop="true"
          height="156px"
        >
          <el-carousel-item>
            <img src="@/assets/quickfix/quickbanner.png" alt>
          </el-carousel-item>
          <el-carousel-item>
            <a
              href="https://activity.lenovo.com.cn/repair-service/index.html?&pmf_group=qav&pmf_medium=qav&pmf_source=Z00009017T000"
            >
              <img src="@/assets/quickfix/homebanner2.png" alt>
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <img src="@/assets/quickfix/quickbanner.png" alt>
          </el-carousel-item>
          <el-carousel-item>
            <a
              href="https://activity.lenovo.com.cn/repair-service/index.html?&pmf_group=qav&pmf_medium=qav&pmf_source=Z00009017T000"
            >
              <img src="@/assets/quickfix/homebanner2.png" alt>
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="content">
        <div class="nag">
          <!-- <el-button type="primary" size="mini" @click="toindex">查看更多工具</el-button> -->
          <el-button type="primary" size="mini" @click="toneeds">提交工具需求</el-button>
        </div>
        <div class="message">
          <div class="m_title">
            {{message.name}}
            <span>{{message.versions}}</span>
          </div>
          <p>工具描述:{{message.description}}</p>
        </div>
        <div class="message2">
          <p style="font-weight:bold;color:#409EFF;">非常感谢您协助联想解决软件工具存在的问题，提升软件工具质量；</p>
          <p style="font-weight:bold;color:#409EFF;">如软件工具未能解决您电脑的问题，请您联系联想客服，联想客服会竭力帮您解决问题；</p>
          <p>
            联想服务联系方式：
            <a
              target="_block"
              href="https://newsupport.lenovo.com.cn/contacts.html?v=d00214a0f0cbadb6e1ae5edaa23359cd"
            >点击查看</a>
          </p>
        </div>
        <div style="margin-top:30px">
          <el-input
            type="textarea"
            v-model="value.content"
            :rows="12"
            placeholder="请输入在工具使用过程中遇见的问题，限500字"
          ></el-input>
        </div>
        <div class="upload" style="margin-top:20px">
          <div class="upload_title">相关图片：</div>
          <div class="upload_main">
            <el-upload
              class="upload-demo"
              action="/Home/Index/uploadForPc"
              :on-remove="handleRemove"
              :on-success="onsuccess"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :file-list="fileList"
              name="image"
              list-type="picture"
              :on-exceed="handleExceed"
			  :on-progress="checkFile"
			  :on-change="onchange"
		
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <span class="upload_atation">请上传本地图片，大小不超过3M，格式为jpg，gif，png，或bmp。</span>
            </el-upload>
          </div>
        </div>
        <div style="margin-top:40px;display:flex;">
          <span style="display:inline-block;width:88px;line-height:40px">联系方式</span>
          <el-input
            type="text"
            v-model="value.contact"
            placeholder="请输入您的联系方式,例如：QQ：8888、微信：weixin、电话号码：18155558888等"
          ></el-input>
        </div>
        <div style="margin-top:40px;text-align:center">
          <el-button type="primary" @click="adddata" style="width:150px">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// getInfo
import { getInfo, addFeedback } from '@/api/forout.js'
export default {
  data () {
    return {
      fileList: [],
      message: {
        description: '',
        name: '',
        versions: ''
      },
      value: {
        id: 1,
        content: '',
        contact: '',
        img: '',
		if_pc:1
      },
      kittle: true,
	  headers:{
		  "Content-Type":"multipart/form-data;boundary=<calculated when request is sent>"
	  },
	  picArr:[]
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.value.id = this.$route.query.id
    } else {
      alert('工具id为空')
      return
    }
    this.getdata()
    // 百度统计
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?1ec74eb78ee62b65a3ee3055c9d7b2e5'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  },
  methods: {
    toindex () {
      // this.$router.push("/index");
      // window.location.href = "http://iknow.lenovo.com/detail/dc_172545.html";
      // window.location.href = 'https://iknow.lenovo.com.cn/tool/lists'
    },
    toneeds () {
      this.$router.push('/needs')
    },
    // 图片上传操作
    handleRemove (file, fileList) {
		console.log(file,fileList,'----remove钩子----')
		fileList.map(item=>{
			console.log(item)
		})
	},
    onsuccess (res, file, fileList) {
		console.log(res,'--res--onsuccess--')
      if (res.code == 200) {
        this.fileList = fileList;
		 var strNew = this.value.img.length>0? ',' + res.data :res.data;
	      this.value.img = this.value.img  +  strNew;
		
      } else {
        alert(res.message)
      }
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    getdata () {
      getInfo({ id: this.$route.query.id }).then(res => {
        if (res.data.code == 200) {
          this.message = res.data.data
        }
      })
    },
    adddata () {
      if (this.kittle) {
        this.kittle = false
        // this.value.img = this.fileList
        //   .map((item, index) => {
        //     return item.response.data
        //   })
        //   .join(',')
        this.kittle = false;
		console.log(this.value,'-----value-----')
        addFeedback(this.value).then(res => {
          this.kittle = true
          alert(res.data.message)
          if (res.data.code == 200) {
            window.location.href =
              'https://iknow.lenovo.com.cn/topic/q_0x1951c43_0?type=yjwt&q1title=Lenovo%20Quick%20Fix%20%E8%81%94%E6%83%B3%E6%99%BA%E8%83%BD%E8%A7%A3%E5%86%B3%E5%B7%A5%E5%85%B7'
          }
        })
      }
    },
	checkFile(event, file, fileList){
	
	},
	onchange(file, fileList){
		console.log(fileList,'onchange')
		// var str = '';
		// fileList.map(item=>{
		// 	if(item.response.code==200){
		// 		str=str + item.response.data.img_url + ',';
		// 	}
			
		// })
		// this.value.img = str;
		
	}
  }
}
</script>
<style lang="scss" scoped>
.header {
  height: 120px;
  background: #4da7f8;
  box-shadow: 5px 0 25px 0 #ddd;
  color: #fff;
  text-align: center;
  line-height: 70px;
  padding-top: 30px;
  box-sizing: border-box;
  font-size: 38px;
  // font-weight: bold;
  margin: 0 -8px;
  .header_wrap {
    position: relative;
    width: 1160px;
    margin: 0 auto;
    img{
      position: absolute;
      left: 0;
    }
    > span {
      margin-left: 10px;
    }
  }
}
.all {
  background: #eff5fa;
  padding-bottom: 10px;
}
.main {
  width: 1160px;
  margin: 0 auto;
  .banner {
    margin-top: 20px;
    height: 156px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    margin: 30px 0px;
    background: #fff;
    padding: 40px 60px;
    text-align: left;
    .nag {
      text-align: right;
    }
    .message {
      border: 1px solid #bdd9ff;
      box-sizing: border-box;
      padding: 10px;
      border-radius: 5px;
      margin-top: 30px;
      .m_title {
        color: #0c6ff6;
        font-size: 18px;
        font-weight: 600;
        padding: 10px;
        border-bottom: 1px solid #bdd9ff;
      }
      p {
        color: #687485;
        font-size: 14px;
        padding: 10px;
        margin: 10px 0 0;
      }
    }
    .message2 {
      border: 1px solid #bdd9ff;
      box-sizing: border-box;
      padding: 10px;
      border-radius: 5px;
      margin-top: 30px;
      p {
        color: #687485;
        font-size: 14px;
        padding: 0 10px;
        margin: 5px 0 0;
      }
    }
  }
}
.upload {
  overflow: hidden;
}
.upload_title {
  float: left;
  width: 90px;
}
.upload_main {
  float: left;
  width: calc("100%-90px");
}
// .upload_atation{
//   position: absolute;
//   top:5px;
//   left:180px;
// }
</style>



// WEBPACK FOOTER //
// src/pages/suggest.vue